module.exports = __webpack_public_path__ + "static/12factor-88a8de1e1ae2f34522d881a8bd3e1bc9.png";